import { handleActions } from 'redux-actions';
import { caseInitialState } from './constants';
import { createGDPRCase, createCCPACase } from './actions';

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [createGDPRCase]: {
    next: (state: State.Case, action: any): State.Case => ({
      ...state,
      CaseData: action.payload,
    }),

    throw: (state: State.Case, action: any): State.Case => ({
      ...state,
      error: action.payload, // TODO
    }),
  },
  [createCCPACase]: {
    next: (state: State.Case, action: any): State.Case => ({
      ...state,
      CaseData: action.payload,
    }),

    throw: (state: State.Case, action: any): State.Case => ({
      ...state,
      error: action.payload, // TODO
    }),
  },
};
export default handleActions(ACTION_HANDLERS, caseInitialState);
